import { Agent } from '@models/agent.model';
import classNames from 'classnames';
import { Icon, ToolTip, TruncatedText } from '@testsigma/atoms';
import { LabLogo } from '../../ui';
import { ExecutionLabType } from '@modules/test-development/enums/execution-lab-type.enum';

interface HybridLabTypeProps {
  agent?: Agent;
  className?: string;
  variant?: 'detail' | 'concise';
  tooltipPlacement?: any;
  hideIcon?: boolean;
  tooltipContent?: string;
  externalAgentType?: string;
  iconName: string;
  tooltipClassName?: string;
}

export const HybridLabType: React.FC<HybridLabTypeProps> = ({
  agent,
  className,
  variant = 'concise',
  tooltipContent = agent?.system?.title,
  tooltipPlacement,
  hideIcon = false,
  externalAgentType,
  tooltipClassName,
  iconName,
}) => {
  return (
    <span className={classNames('flex flex-row items-center', className)}>
      {!hideIcon && (
        <ToolTip
          content={variant !== 'detail' ? tooltipContent : ''}
          placement={tooltipPlacement}
          align='center'
          className='flex items-center justify-center'
          tooltipClassName='!max-w-[250px]'
        >
          <Icon
            className={classNames(
              'text-secondary-400 group-hover:text-secondary-unique-800 hover:text-secondary-unique-800 text-base',
              {
                'text-base leading-5': variant == 'concise',
              },
            )}
            name={iconName}
          ></Icon>
        </ToolTip>
      )}

      {variant === 'detail' && (
        <a
          className={classNames('w-11/12', {
            'ml-2': !hideIcon,
          })}
          href={'/ui/agents/' + agent?.id}
        >
          <TruncatedText
            className='inline-block'
            value={tooltipContent}
            toolTipPlacement={tooltipPlacement}
            tooltipClassName={tooltipClassName}
          />
        </a>
      )}
    </span>
  );
};
